import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Clock } from "lucide-react";
import { CHART, ChartCard, ChartEmpty, TooltipBox, axisTick } from "./ui";

const formatHour = (h) => {
  if (h === 0) return "12am";
  if (h === 12) return "12pm";
  return h < 12 ? `${h}am` : `${h - 12}pm`;
};

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload || payload.length === 0) return null;
  const d = payload[0]?.payload || {};
  return <TooltipBox title={formatHour(d.hour)}><span>{d.count} bookings confirmed</span></TooltipBox>;
};

const PeakHoursChart = ({ hours }: any) => {
  const card = (body) => (
    <ChartCard icon={<Clock />} title="Peak Booking Hours" description="Time of day when bookings are confirmed.">{body}</ChartCard>
  );
  if (!hours || hours.length === 0) {
    return card(<ChartEmpty icon={<Clock />} text="No booking hour data available" />);
  }

  const maxCount = Math.max(...hours.map((h) => h.count));
  const chartData = hours.map((h) => ({ ...h, label: formatHour(h.hour) }));

  return card(
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={chartData} margin={{ top: 20, right: 10, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART.grid} vertical={false} />
        <XAxis dataKey="label" tick={axisTick} tickLine={false} axisLine={{ stroke: CHART.grid }} />
        <YAxis tick={axisTick} tickLine={false} axisLine={false} allowDecimals={false} />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "var(--accent)" }} />
        <Bar dataKey="count" radius={[4, 4, 0, 0]} label={{ position: "top", fontSize: 11, fill: CHART.text }}>
          {chartData.map((entry, idx) => (
            <Cell key={idx} fill={CHART.primary} fillOpacity={entry.count === maxCount ? 1 : 0.4} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default PeakHoursChart;
